<!-- Redirect Root -->
<!-- This component handles the redirect from Google Authen -->

<template>
  <div>
    redirecting...
  </div>
</template>

<script>
  // const redirect = {
  //   resetPassword: param => `/resetpassword${param}`,
  //   revertSecondFactorAddition: param => `/revertsecondfactoraddition${param}`,
  // }
  import { PostAuthUserLoginProcess } from '@/helpers/users'
  import store from '@/store'
  import i18n from '@/i18n'
  import { cookies } from '@/util/cookies'
  import { iframeAuth } from '@/services/iframeAuth'

  export default {
    name: 'Iframe',
    data () {
      return {
        ready: false,
      }
    },
    async mounted () {
      console.log('redirecting')
      const { path, lang } = this.$route.query

      this.clearExistingAuthCookies()

      iframeAuth.init()

      // Wait for token from BS-GO (with timeout fallback)
      await this.waitForToken(5000)

      // Get token and config (either from postMessage or URL fallback)
      const token = iframeAuth.getToken()
      const config = iframeAuth.getConfig()

      if (!token) {
        console.error('No authentication token available')
        return
      }

      // Process login with received credentials
      const uid = config.uid || this.$route.query.uid
      if (uid) {
        await PostAuthUserLoginProcess({ uid: uid }, store, i18n)
      }

      if (lang) {
        cookies.set('locale', lang)
        this.$i18n.locale = lang
      }
      console.log(this.$i18n.locale)

      this.ready = true
      return this.$router.push(`/admin/${path}`)
    },
    methods: {
      clearExistingAuthCookies () {
        // Clear all existing auth-related cookies before initializing new session
        cookies.remove('token')
        cookies.remove('account')
        cookies.remove('user')
        cookies.remove('baseUrl')
        cookies.remove('apikey')
      },
      waitForToken (timeout) {
        return new Promise((resolve) => {
          // If already have token, resolve immediately
          if (iframeAuth.getToken()) {
            resolve()
            return
          }

          // Wait for token update via postMessage
          const unsubscribe = iframeAuth.onTokenUpdate(() => {
            unsubscribe()
            resolve()
          })

          // Timeout fallback (use URL params if postMessage fails)
          setTimeout(() => {
            if (!iframeAuth.getToken()) {
              console.warn('Token not received via postMessage, falling back to URL')
              this.fallbackToUrlParams()
            }
            unsubscribe()
            resolve()
          }, timeout)
        })
      },
      fallbackToUrlParams () {
        // Legacy fallback for backward compatibility
        const { token, account, user, uid, url, apikey } = this.$route.query
        if (token) {
          iframeAuth.handleTokenUpdate({
            token,
            accountId: account,
            userId: user,
            uid,
            baseUrl: url,
            apiKey: apikey,
          }, 'URL params')
        }
      },
    },
  }
</script>
